// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"88cf1d3e","423":"88cf1d3e","617":"88cf1d3e","914":"b5bcec93"}[chunkId] + ".chunk.css";
};